import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { Attribute, Layer, Project, Service } from '../../classes';
import { LayerService } from '../../services';

@Component({
  selector: 'geo-crowdsource',
  templateUrl: 'crowdsource.component.html',
  styleUrls: ['./crowdsource.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CrowdsourceComponent implements OnChanges {
  @Input() project: Project;

  @Output() onLayerCreate = new EventEmitter();

  layers: Layer[] = [];
  selectedLayer: Layer;

  constructor(private layerService: LayerService, private ref: ChangeDetectorRef) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.project.currentValue) {
      this.flattenLayerList(changes.project.currentValue.layers);

      if (this.project.crowdsource_layer) {
        if (this.project.crowdsource_layer.attributes) {
          const attributes = this.project.crowdsource_layer.attributes = this.project.crowdsource_layer.attributes.map(attr => new Attribute(attr));
          this.project.crowdsource_layer.crowdsourceAttributes = attributes.filter(attribute => attribute.crowdSource);
          this.ref.markForCheck();
        } else {
          this.layerService.getAttributes(this.project.crowdsource_layer).subscribe(attributes => {
            this.project.crowdsource_layer.attributes = attributes;
            this.project.crowdsource_layer.crowdsourceAttributes = attributes.filter(attribute => attribute.crowdSource);
            // this.project.crowdsource_layer.crowdsourceAttributes.forEach(attr => attr.crowdsourceSettings = {});
            this.ref.markForCheck();
          });
        }
      }
    }
  }

  selectLayer(layer: Layer) {
    this.selectedLayer = layer;
    if (!this.selectedLayer.attributes) {
      this.layerService.getAttributes(this.selectedLayer).subscribe(attributes => {
        layer.attributes = attributes;
        this.ref.markForCheck();
      });
    }
  }

  setLayer() {
    this.project.crowdsource_layer = this.selectedLayer;
    this.project.crowdsource_layer.crowdsource = true;
  }

  resetLayer() {
    this.project.crowdsource_layer.crowdsource = false;

    this.project.crowdsource_layer.attributes.forEach(attr => {
      attr.crowdSource = false;
    });

    this.project.crowdsource_layer.crowdsourceAttributes = [];

    this.project.crowdsource_layer = null;
    this.selectedLayer = null;
  }

  toggleAttr(attr: Attribute) {
    const attrs = this.project.crowdsource_layer.crowdsourceAttributes;

    if (!attr.crowdSource) {
      attr.crowdSource = true;
      attrs.push(attr);
    } else {
      attr.crowdSource = false;
      attrs.splice(attrs.indexOf(attr), 1);
    }
  }

  createLayer() {
    this.onLayerCreate.emit();
  }

  private flattenLayerList(layers: Layer[]) {
    layers.forEach(layer => {
      if (layer.service instanceof Service && layer.service && layer.service.editable) {
        this.layers.push(layer);
      }
      this.flattenLayerList(layer.sublayers);
    });
  }
}
